<template>
<v-card height="100%" color="darkBackgroundAccent" dark>
    <v-card-title style="padding: 0 12px">
        <v-icon>mdi-view-list</v-icon>
        <span>Plan de Reacción</span>
    </v-card-title>

    <v-card-text>
    <v-stepper  v-model="e6" class="stepper_horizontal">
        <v-stepper-items>
            <template v-for="item in steps">      
            <v-stepper-content :step="item.Step" :key="`${item.Step}-content`">
                <LlamadaContactos v-if="item.StepType == StepType.LLAMADA_CONTACTO"/>
                <LlamadaAutoridades v-if="item.StepType == StepType.LLAMADA_AUTORIDADES"/>
                <CorreoContactos v-if="item.StepType == StepType.CORREO_CONTACTO"/>
                <CorreoOtro v-if="item.StepType == StepType.CORREO_OTRO"/>
            </v-stepper-content>     
            </template>
            <v-stepper-content :step="steps.length+1" :key="`${steps.length+1}-content`">
                 <v-stepper v-model="e6" vertical class="stepper_vertical">
                    <template v-for="item in steps">      
                        <v-stepper-step :complete="e6 > item.Step" :step="item.Step"  :key="`${item.Step}-step`">
                            {{item.Title}} <small v-if="item.SmallTitle">{{item.SmallTitle}}</small>
                        </v-stepper-step>
                        <v-stepper-content style="padding: 6px" :step="item.Step" :key="`${item.Step}-content`"/>
                    </template>
                </v-stepper>
            </v-stepper-content>
        </v-stepper-items>
        <div class="center" v-if="e6 <= steps.length">
            <v-btn :disabled="e6 <= 1" icon rounded @click="backStep">
                <v-icon> mdi-arrow-left </v-icon>
            </v-btn>
            <span style="padding: 4px 40px">
                Paso {{e6}} de {{steps.length}}
            </span>
            <v-btn icon rounded @click="continueStep">
                <v-icon> mdi-arrow-right </v-icon>
            </v-btn>
        </div>
    </v-stepper>
    </v-card-text>

<!--     <v-dialog v-model="showDialog " max-width="500px">
        <v-card>
            <v-card-actions>
            <v-btn color="primary"  @click.stop="showDialog=false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog> -->
</v-card>
</template>


<script>

import {StepType} from './helpers'

import CorreoContactos from '@/components/PlanReaccion/PlanReaccionCorreoContactos.vue'
import CorreoOtro from '@/components/PlanReaccion/PlanReaccionCorreoOtro.vue'
import LlamadaAutoridades from '@/components/PlanReaccion/PlanReaccionLlamadaAutoridades.vue'
import LlamadaContactos from '@/components/PlanReaccion/PlanReaccionLlamadaContactos.vue'
import EventBus from '@/components/event-bus'


export default {
    name: 'PlanReaccion',
    props:{
        title: String
    },
    components:{
        CorreoContactos,
        CorreoOtro,
        LlamadaAutoridades,
        LlamadaContactos
    },
    data: () => ({
        showDialog: false,
        StepType,
        e6: 1,
        steps:[
            {
                Title: "Llamar a contacto",
                /*SmallTitle: "Es necesario contactar al interesado",*/
                StepType: StepType.LLAMADA_CONTACTO,
                Step: 1
            },
            {
                Title: "Llamar a autoridades",
                StepType: StepType.LLAMADA_AUTORIDADES,
                Step: 2
            },
            {
                Title: "Correo a contacto",
                StepType: StepType.CORREO_CONTACTO,
                Step: 3
            },
            {
                Title: "Correo a otro",
                StepType: StepType.CORREO_OTRO,
                Step: 4
            }
        ]
    }),
    methods:{
        continueStep(){
            this.e6 = this.e6 + 1
        },
        backStep(){
            if(this.e6 > 1)
            this.e6 = this.e6 - 1
        }
    }
}
</script>
<style scoped> 

.stepper_horizontal{
    background:  var(--v-darkBackgroundAccent-base) !important
}

.stepper_vertical{
    padding-bottom: 20px; 
    background:  var(--v-darkBackgroundAccent-base) !important
}

.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
  padding: 0;
}

.center {
  width: 80%;
  text-align: center;
  margin: auto;
  padding: 10px;
}

.v-stepper__content{
  padding: 10px;
}

.btn-fix:focus::before { opacity: 0 !important; }
</style>